import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import EpisodeList from "../../components/movie/EpisodeList";
import HeaderMovie from "../../components/movie/HeaderMovie";
import InfoMovie from "../../components/movie/InfoMovie";
import ListCount from "../../components/movie/ListCount";
import OptionMovie from "../../components/movie/OptionMovie";
import VideoPlayer from "../../components/movie/VideoPlayer";
import Header from "../../components/ui/Header";
import ListHorizontal from "../../components/ui/ListHorizontal";
import { useEpisodes } from "../../hooks/useEpisodes";
import { usePostDetails } from "../../hooks/usePost";
import Footer from "../../components/layout/Footer";
import HeaderPost from "../../components/movie/HeaderPost";

const GameDetail: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const location = useLocation();
  const [game, setGame] = useState(location.state?.item || null);
  const { data: fetchedGame } = usePostDetails(slug || "", "game");
  const [descExpanded, setDescExpanded] = useState(false);
  const [chapterExpanded, setChapterExpanded] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const { episodes: rawChapters } = useEpisodes("game", game?.id || "",slug || "");
  const [currentChapterUrl, setCurrentChapterUrl] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
    setDescExpanded(false);
    setChapterExpanded(false);
    setIsPlaying(false);
    setCurrentChapterUrl("");
  }, [slug]);

  const handlePlayChapter = (chapterUrl: string) => {
    setIsPlaying(true);
    setCurrentChapterUrl(chapterUrl);
  };

  useEffect(() => {
    if (fetchedGame) {
      setGame(fetchedGame);
    }
  }, [fetchedGame]);

  useEffect(() => {
    if (rawChapters.length > 0 && !currentChapterUrl) {
      setCurrentChapterUrl(rawChapters[0].source[0]?.link || "");
    }
  }, [rawChapters, currentChapterUrl]);

  if (!game) {
    return (
      <div className="game-details bg-mainBlack">
        <h1 className="text-2xl">Không tìm thấy game</h1>
      </div>
    );
  }

  return (
    <div className="game-details bg-mainBlack text-white min-h-screen w-full">
      <Header isBack/>
       <HeaderPost
          title={game?.title||""}
          banner={game.banner}
           type="movie" 
            
          
        />
      <ListCount
        episodeTotal={rawChapters?.length || 0}
        likeCount={game.like_count}
        ratingAvg={game.rating_avg}
      />
      {!isPlaying && (
        <EpisodeList
          currentVideoUrl={currentChapterUrl}
          episodes={rawChapters || []}
          movieSlug={game.slug}
         
          onPlayEpisode={handlePlayChapter}
        />
      )}
      <OptionMovie
        episodeTotal={game.episode_total}
        likeCount={game.like_count}
        ratingAvg={game.rating_avg}
        onPlay={() => setIsPlaying(true)}
        isPlaying={isPlaying}
        post={game}
      />
      <InfoMovie
        releaseYear={game.release_year || []}
        categories={game.categories || []}
        directors={game.directors || []}
        actors={game.actors || []}
        description={game.description || ""}
        descExpanded={descExpanded}
        setDescExpanded={setDescExpanded}
      />
      <ListHorizontal
        title={game.related_post?.button.label}
        type={game.related_post?.button.type}
        posttype="game"
        movies={game.related_post?.items || []}
        api={game.related_post?.button.data.api}
      />
      <Footer />
    </div>
  );
};

export default GameDetail;
